import React from 'react'

const variants = {
  Active: { cls: 'branch-badge-active', label: 'Active' },
  Deleted: { cls: 'branch-badge-deleted', label: 'Deleted' },
  Inactive: { cls: 'branch-badge-inactive', label: 'Inactive' },
}

export default function BranchBadge({ status = 'Active' }) {
  const v = variants[status] || variants.Active
  return (
    <span className={`branch-badge ${v.cls}`}>
      <span className='branch-badge-dot' />
      {v.label}
    </span>
  )
}
